export enum FilterDisplayHintType {
  None,
  CheckBox,
  Radio,
  TextBox,
  Range
}
